import { apiClient } from "./client"

export async function fetchUschovy() {
  return apiClient.get("/uschovy")
}

export async function fetchUschova(id) {
  return apiClient.get(`/uschovy/${id}`)
}

export async function fetchUschovaDetail(id) {
  return apiClient.get(`/uschovy/detail/${id}`)
}

export async function updateUschovaVozidlo(idVozidla, payload) {
  return apiClient.put(`/uschovy/vozidlo/${idVozidla}`, payload)
}

export async function updateUschovaZakaznik(idZakaznika, payload) {
  return apiClient.put(`/uschovy/zakaznik/${idZakaznika}`, payload)
}

export async function updateUschovaZakazka(idZakazky, payload) {
  return apiClient.put(`/uschovy/zakazka/${idZakazky}`, payload)
}

export async function issueUschovaZakazka(idZakazky, typVydeje) {
  return apiClient.put(`/uschovy/zakazka/${idZakazky}/vydej`, { typ_vydeje: typVydeje })
}

export async function createUschovaPrijem(payload) {
  return apiClient.post('/uschovy/zakazka/prijem', payload)
}

export async function fetchUschovaDalsiCislo(datum) {
  const qs = new URLSearchParams()
  if (datum) qs.set('datum', String(datum))
  const q = qs.toString()
  return apiClient.get(q ? `/uschovy/zakazka/dalsicislo?${q}` : '/uschovy/zakazka/dalsicislo')
}

export async function fetchUschovaNapoveda(field, q) {
  const qs = new URLSearchParams()
  qs.set("field", String(field || ""))
  qs.set("q", String(q || ""))
  return apiClient.get(`/uschovy/napoveda?${qs.toString()}`)
}

export async function createUschovaKarta(payload) {
  return apiClient.post("/uschovy/karta", payload)
}

export async function createUschova(payload) {
  return apiClient.post("/uschovy", payload)
}

export async function updateUschova(id, payload) {
  return apiClient.put(`/uschovy/${id}`, payload)
}

export async function deleteUschova(id) {
  return apiClient.del(`/uschovy/${id}`)
}
